import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import './IndustryDistribution.css';

ChartJS.register(ArcElement, Tooltip, Legend);

const IndustryDistribution = () => {
  const industryData = [
    { name: 'Fashion & Luxury', value: 35, brands: ['Louis Vuitton', 'Chanel', 'Prada'] },
    { name: 'Beauty & Wellness', value: 25, brands: ['Sephora', 'Rare Beauty', 'Fenty'] },
    { name: 'Tech & Media', value: 20, brands: ['Netflix', 'Prime Video', 'Hulu'] },
    { name: 'Sports & Lifestyle', value: 10, brands: ['Nike', 'Adidas', 'Jordan'] },
    { name: 'Food & Beverage', value: 5, brands: ['Nescafé', 'Coca-Cola'] },
    { name: 'Other', value: 5, brands: ['Travel', 'Finance', 'etc.'] }
  ];

  const data = {
    labels: industryData.map(d => d.name),
    datasets: [{
      data: industryData.map(d => d.value),
      backgroundColor: [
        'rgba(255, 99, 132, 0.8)',
        'rgba(54, 162, 235, 0.8)',
        'rgba(255, 206, 86, 0.8)',
        'rgba(75, 192, 192, 0.8)',
        'rgba(153, 102, 255, 0.8)',
        'rgba(255, 159, 64, 0.8)'
      ],
      borderColor: [
        'rgba(255, 99, 132, 1)',
        'rgba(54, 162, 235, 1)',
        'rgba(255, 206, 86, 1)',
        'rgba(75, 192, 192, 1)',
        'rgba(153, 102, 255, 1)',
        'rgba(255, 159, 64, 1)'
      ],
      borderWidth: 2
    }]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          color: 'rgba(255, 255, 255, 0.8)',
          padding: 15,
          font: {
            size: 12
          }
        }
      },
      title: {
        display: true,
        text: 'Industry Distribution - Tokenization Opportunities',
        color: '#C3FF00',
        font: {
          size: 18,
          weight: 'bold'
        },
        padding: {
          bottom: 20
        }
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const industry = industryData[context.dataIndex];
            return [
              `${industry.name}: ${industry.value}%`,
              `Key brands: ${industry.brands.slice(0, 3).join(', ')}`
            ];
          }
        }
      }
    }
  };

  return (
    <div className="industry-distribution glass-card">
      <div className="chart-container">
        <Doughnut data={data} options={options} />
      </div>
      <div className="industry-insights">
        <div className="insight-item">
          <span className="insight-icon">👗</span>
          <span className="insight-label">Fashion leads with 35% share</span>
        </div>
        <div className="insight-item">
          <span className="insight-icon">💄</span>
          <span className="insight-label">Beauty sector shows high engagement</span>
        </div>
        <div className="insight-item">
          <span className="insight-icon">🚀</span>
          <span className="insight-label">Tech partnerships growing rapidly</span>
        </div>
      </div>
    </div>
  );
};

export default IndustryDistribution;